import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectToken } from 'store/users/users.selectors'
import { getCertificateRequest } from 'requests/certificate'
import TextWithPrefixAndCopy from 'components/molecules/TextWithPrefixAndCopy'

export type CertificateInfoProps = {
  type: string
  identityData: { [key: string]: string }
}

const extractInfoText = (data: any): string | null => {
  const info = data?.passport?.['Информация']
  return typeof info === 'string' && info.trim() ? info.trim() : null
}

const CertificateInfo: React.FC<CertificateInfoProps> = ({ type, identityData }) => {
  const token = useSelector(selectToken)
  const [infoText, setInfoText] = useState<string | null>(null)

  useEffect(() => {
    let alive = true

    const hasEmpty = Object.values(identityData).some((v) => !v)
    if (hasEmpty) return
    ;(async () => {
      try {
        const data = await getCertificateRequest(type, identityData, String(token ?? ''))
        if (!alive) return
        setInfoText(extractInfoText(data))
      } catch {
        if (!alive) return
        setInfoText(null)
      }
    })()

    return () => {
      alive = false
    }
  }, [type, identityData, token])

  if (!infoText) return null

  return <TextWithPrefixAndCopy prefix="Информация:" text={infoText} copiedText={infoText} />
}

export default CertificateInfo
